{
  "name": "tetras",
  "version": "5.1.0",
  "type": "module",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "prebuild": "npm run timestamp",
    "build": "ng build --configuration=production",
    "build-dev": "npm run timestamp && ng build --configuration=development",
    "watch": "ng build --watch --configuration production",
    "lint": "ng lint",
    "timestamp": "node ./timestamp.js"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.16",
    "@angular/cdk": "^21.2.14",
    "@angular/common": "^21.2.16",
    "@angular/compiler": "^21.2.16",
    "@angular/core": "^21.2.16",
    "@angular/forms": "^21.2.16",
    "@angular/google-maps": "^21.2.14",
    "@angular/material": "^21.2.14",
    "@angular/platform-browser": "^21.2.16",
    "@angular/platform-browser-dynamic": "^21.2.16",
    "@angular/router": "^21.2.16",
    "@angular/service-worker": "^21.2.16",
    "@fullcalendar/angular": "^6.1.20",
    "@fullcalendar/core": "^6.1.20",
    "@fullcalendar/daygrid": "^6.1.20",
    "@fullcalendar/interaction": "^6.1.20",
    "@fullcalendar/resource-timeline": "^6.1.20",
    "@fullcalendar/timegrid": "^6.1.20",
    "@mineminemine/angular-signature-pad": "^7.0.0",
    "@zxing/ngx-scanner": "^21.0.0",
    "angular-gridster2": "^21.0.1",
    "base64-blob": "^1.4.1",
    "date-fns": "^3.6.0",
    "exceljs": "^4.4.0",
    "file-saver": "^2.0.5",
    "firesql": "^2.0.2",
    "font-awesome": "^4.7.0",
    "highcharts": "^12.6.0",
    "highcharts-angular": "^5.4.0",
    "html-to-pdfmake": "^2.5.33",
    "jspdf": "^4.2.1",
    "moment-timezone": "^0.6.2",
    "ngx-image-compress": "^18.1.7",
    "os-browserify": "^0.3.0",
    "pdfmake": "^0.2.23",
    "replace-in-file": "^8.4.0",
    "rxjs": "^7.8.2",
    "tippy.js": "^6.3.7",
    "tslib": "^2.8.1",
    "xlsx": "^0.18.5",
    "xslt-processor": "^5.0.11",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^21.4.0",
    "@angular-eslint/eslint-plugin": "^21.4.0",
    "@angular-eslint/eslint-plugin-template": "^21.4.0",
    "@angular-eslint/schematics": "^21.4.0",
    "@angular-eslint/template-parser": "^21.4.0",
    "@angular/build": "^21.2.14",
    "@angular/cli": "^21.2.14",
    "@angular/compiler-cli": "^21.2.16",
    "@types/express": "^4.17.2",
    "@types/express-serve-static-core": "^4.17.20",
    "@types/file-saver": "^2.0.7",
    "@types/google.maps": "3.64.1",
    "@types/node": "^20.19.41",
    "@types/pdfmake": "^0.2.13",
    "@types/ws": "^8.18.1",
    "@typescript-eslint/eslint-plugin": "^8.60.1",
    "@typescript-eslint/parser": "^8.60.1",
    "eslint": "^9.39.4",
    "eslint-plugin-import": "^2.32.0",
    "nx": "^22.7.5",
    "typescript": "~5.9.3"
  }
}
